import React from 'react'
import { Route } from 'react-router'
import RedirectToPlural from '@/modules/layout/util/redirectToPlural'

const CancellationDetails = React.lazy(() => import('@/modules/cancellation/components/detail/cancellation-detail.component'))
const TransactionSendEmail = React.lazy(() => import('@/modules/transaction/components/email/transaction-send-email'))

const cancellationRoutes = (
  <>
    <Route path='cancellation/*' element={<RedirectToPlural />} />
    <Route path='cancellations/:id' Component={CancellationDetails} />
    <Route path='cancellations/send/:id' Component={TransactionSendEmail} handle={{ options: { noBackgroundColor: true } }} />
  </>
)

export default cancellationRoutes
